module.exports = __webpack_public_path__ + "img/defense.044aa690.svg";